import { present } from 'shared/presenters/presenter'
import { Widgets } from 'shared/presenters/graphqlTypes'

export class WidgetPresenter extends present<Widgets>() {}
